import { addTrackingData, generalCallbacks } from './general';
const callbackModifierCallback = (callbackData) => {
    const data = generalCallbacks.submitModifierCallback(callbackData);
    if (data === null) {
        return null;
    }
    data.customer_comments_c = '';
    if (data.instant_callback == 'callback-date-time') {
        data.customer_comments_c += 'Callback Type : Datum angeben' + ', Zeitpunkt für Rückruf : ' + data.callback_date;
    }
    if (data.instant_callback == 'callback-instant') {
        data.customer_comments_c += 'Callback Type : Sofortiger Rückruf';
    }
    delete data.instant_callback;
    delete data.callback_date;
    return addTrackingData(data);
};
export const callbackCallbacks = {
    callbackModifierCallback,
};
